import AmpersandCollection from 'ampersand-collection';
import WorkScheduleAccessModel from './work-schedule-access-model';

import _ from 'lodash';

const WorkScheduleAccessCollection = AmpersandCollection.extend({
    model: WorkScheduleAccessModel,

    getUserCompaniesAvailable(userId) {
        let res;
        const selfId = gd.session.me.id;
        if (!userId || userId === selfId) {
            res = gd.session.companies.map(c=>c.id);
        } else {
            const userCompanies = gd.session.companyUsers.filterByUser(userId).map(cu=>cu.company.id);
            const userAccessCompanies = [];

            this.models.map(wsa=>{
                if (wsa.targetUserId === selfId && wsa.userId === userId)
                    userAccessCompanies.push(wsa.companyId)
            });
            res = _.intersection(userCompanies,userAccessCompanies);
        }
        return res;
    }
});

module.exports = WorkScheduleAccessCollection;